import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { Router } from '@angular/router'
import { OrderHistory } from '@monorepo-channels/channels/domain'

@Component({
	standalone: true,
	imports: [CommonModule, MatButtonModule, MatIconModule],
	selector: 'feature-porto-bank-success-cancel-order',
	template: `
		<section
			style="padding: 16px; display: flex; flex-direction: column; align-items: flex-start; gap: 16px;"
		>
			<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
				<mat-icon svgIcon="porto-bank-icons:alert"></mat-icon>

				<mat-icon
					svgIcon="porto-bank-icons:close-circle"
					(click)="close()"
					style="cursor: pointer;"
				></mat-icon>
			</div>

			<h1 style="font-size: 22px; font-weight: 600; color: #000;">
				{{ order.originalIntent === 'checkin' ? 'Check-in cancelado' : 'Reserva cancelada' }} com
				sucesso!
			</h1>

			<article class="order-card">
				<h2 class="order-card__name">{{ order.venue.name }}</h2>

				<p class="order-card__location">
					{{ order.venue.address.value }}
				</p>

				<div class="order-card__time">
					<p>
						<span>Data:</span> <span>{{ order.reservationDateTime | date: 'dd/MM/YYYY' }}</span>
					</p>
					<p>
						<span>Horário:</span> <span>{{ order.reservationDateTime | date: 'HH:mm' }}</span>
					</p>
				</div>
			</article>

			<div style="display: flex; gap: 8px; align-self: flex-end; margin-top: 16px;">
				<button
					mat-button
					(click)="close()"
					style="background-color: var(--content-primary); color: white; font-weight: 600; font-size: 15px; max-width: 55px; height: 30px"
				>
					Fechar
				</button>
			</div>
		</section>
	`,
	styles: `
		.order-card {
			display: flex;
			flex-direction: column;
			gap: 12px;
			background-color: #fff;
			border-radius: 8px;
            border: 1px solid #E0E0E0;
            padding: 20px;

			&__name {
				font-size: 20px;
				font-weight: 500;
				overflow: hidden;
				color: var(--content-title);
				white-space: nowrap;
				@media (max-width: 375px) {
					width: 200px;
					text-overflow: ellipsis;
				}
			}

            &__time{
                background-color: #EAECF6;
                padding: 16px;
                font-size: 12px;
                font-weight: 480;
                margin: 0 -20px;
                margin-bottom: -20px;
                color: #3C3C3C;
                p{
                    display: flex;
                    gap: 20px;
                    span{
                        width: 20%;
                    }
                }
            }

			&__location {
				font-size: 16px;
				color: var(--content-title);
				font-weight: 400;
			}
		}
	`,
})
export class SuccessCancelOrderComponent {
	public dialogRef = inject(MatDialogRef, { optional: true })
	public order: OrderHistory = inject(MAT_DIALOG_DATA, { optional: true })
	private router = inject(Router)

	close() {
		this.dialogRef?.close()
		this.router.navigate(['/reservas-e-checkins'])
	}
}
